// extracted by mini-css-extract-plugin
export default {"contactIcon":"contact_contactIcon__rODsS","input":"contact_input__E2z0L"};